import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
    return (
        <div className="home">
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-content">
                    <p className="tagline">
                        To improve lives by advocating for inclusive socioeconomic policies, promoting economic empowerment, environmental sustainability, and community-driven development for a dignified and sustainable future in Zambia.
                    </p>
                    <div className="hero-ctas">
                        <Link to="/about" className="btn btn-primary">Learn more about us</Link>
                    </div>
                </div>
            </section>

            {/* Focus Areas (Specific Objectives) */}
            <section className="focus-areas">
                <div className="container">
                    <div className="section-header">
                        <h2>Our Focus Areas</h2>
                        <p>Guided by our specific objectives</p>
                    </div>
                    <div className="cards-grid">
                        <div className="card">
                            <div className="card-icon" aria-hidden>
                                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
                            </div>
                            <h3>Governance</h3>
                            <p>Promote transparency, accountability, and citizen participation in governance processes.</p>
                        </div>
                        <div className="card">
                            <div className="card-icon" aria-hidden>
                                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M3 13h2v-2H3v2zm4 0h14v-2H7v2zM3 17h2v-2H3v2zm4 0h14v-2H7v2zM3 9h2V7H3v2zm4 0h14V7H7v2z"/></svg>
                            </div>
                            <h3>Policy Advocacy & Reform</h3>
                            <p>Advance progressive socioeconomic policies addressing poverty, inequality, and social justice.</p>
                        </div>
                        <div className="card">
                            <div className="card-icon" aria-hidden>
                                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 20h10v-2H7v2zM12 2L2 7l10 5 10-5-10-5zm0 7.18L5.24 7 12 3.82 18.76 7 12 9.18z"/></svg>
                            </div>
                            <h3>Environmental Sustainability</h3>
                            <p>Promote conservation and sustainable practices for a healthy future for all.</p>
                        </div>
                        <div className="card">
                            <div className="card-icon" aria-hidden>
                                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M3 5h18v2H3V5zm0 6h18v2H3v-2zm0 6h18v2H3v-2z"/></svg>
                            </div>
                            <h3>Research & Data Collection</h3>
                            <p>Generate evidence to inform policy and track impact across programmes.</p>
                        </div>
                        <div className="card">
                            <div className="card-icon" aria-hidden>
                                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M10 8H6l-4 4 4 4h4l-4-4 4-4zm8 0h-4l-4 4 4 4h4l-4-4 4-4z"/></svg>
                            </div>
                            <h3>Partnership Building</h3>
                            <p>Work with government, private sector, and NGOs to amplify outcomes.</p>
                        </div>
                        <div className="card">
                            <div className="card-icon" aria-hidden>
                                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12c0 2.85 1.2 5.41 3.11 7.24l1.42-1.42C4.98 16.36 4 14.29 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 2.29-.98 4.36-2.53 5.82l1.42 1.42C20.8 17.41 22 14.85 22 12c0-5.52-4.48-10-10-10zm0 4c-3.31 0-6 2.69-6 6 0 1.66.68 3.16 1.77 4.24l1.42-1.42C8.45 14.09 8 13.1 8 12c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.1-.45 2.09-1.19 2.82l1.42 1.42C17.32 15.16 18 13.66 18 12c0-3.31-2.69-6-6-6zm0 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
                            </div>
                            <h3>Cultural Paradigm Shift</h3>
                            <p>Catalyze measurable shifts in Zambia's cultural paradigms—targeting dimensions such as power distance, uncertainty avoidance, short-termism, and other globally recognized cultural metrics.</p>
                        </div>
                        <div className="card">
                            <div className="card-icon" aria-hidden>
                                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z"/></svg>
                            </div>
                            <h3>Doctrine of Remembrance</h3>
                            <p>Embed remembrance of Zambia's cultural heritage and global historical ruptures into civic education, public rituals, and national consciousness.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Support CTAs with Big Logo (replacing Impact) */}
            <section className="cta-highlight">
                <div className="container cta-inner">
                    <div className="cta-logo-wrap">
                        <img
                            src={`${process.env.PUBLIC_URL}/logo.png`}
                            alt="Let's Change Zambia logo"
                            className="cta-logo"
                            onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
                        />
                    </div>
                    <div className="cta-actions">
                        <div className="hero-ctas">
                            <Link to="/donate" className="btn btn-primary">Support Us</Link>
                            <Link to="/projects" className="btn btn-secondary">Explore Projects</Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Get Involved */}
            <section className="get-involved">
                <div className="container gi-inner">
                    <div>
                        <h2>Get Involved</h2>
                        <p>There are many ways to make a difference—donate, volunteer, or partner with us.</p>
                    </div>
                    <div className="gi-actions">
                        <Link to="/donate" className="btn btn-primary">Donate</Link>
                        <Link to="/contact" className="btn btn-outline">Partner / Volunteer</Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;